import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=650d0ba8&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=js&"
export * from "./Process.vue?vue&type=script&lang=js&"
import style0 from "./Process.vue?vue&type=style&index=0&id=650d0ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d0ba8",
  null
  
)

export default component.exports